module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      with_line: this.$route.path != ('/' + _vm.lang) && this.$route.path != ('/' + _vm.lang + '/') && this.$route.path != '/'
    }
  }, [_c('div', {
    staticClass: "holder big"
  }, [_c('a', {
    staticClass: "alogo",
    attrs: {
      "href": '/' + _vm.lang + '/'
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../images/logo.png")
    }
  })]), _vm._v(" "), _c('nav', [_c('ul', [_c('li', [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['SOLUTIONS']))]), _vm._v(" "), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/platform'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v("GL Enterprise Platform")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/cloud-credit'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v("Cloud Credit")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/bid-pro'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v("Bid Pro")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/loyalty'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v("Loyalty")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/global-centre'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v("Global Centre")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/resource-management'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v("Resource Management")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/solutions/aspa'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v("ASPA")])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['SERVICES']))]), _vm._v(" "), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/services/engineering'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['ENGINEERING']))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/services/development'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['DEVELOPMENT']))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/services/consulting'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['CONSULTING']))])])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/news'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['PRESS_CENTER']))])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['COMPANY']))]), _vm._v(" "), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/company/about'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['ABOUT_COMPANY']))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/company/documents'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['DOCUMENTS']))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/company/career'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['CAREER']))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": '/' + _vm.lang + '/company/contacts'
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.content[_vm.lang]['CONTACTS']))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "lang_mobile"
  }, [_c('a', {
    class: {
      curr: _vm.lang == 'ru'
    },
    attrs: {
      "href": "/ru"
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.langName('ru')))]), _vm._v(" "), _c('a', {
    class: {
      curr: _vm.lang == 'en'
    },
    attrs: {
      "href": "/en"
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.langName('en')))]), _vm._v(" "), _c('a', {
    class: {
      curr: _vm.lang == 'zh'
    },
    attrs: {
      "href": "/zh"
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.langName('zh')))]), _vm._v(" "), _c('a', {
    class: {
      curr: _vm.lang == 'hi'
    },
    attrs: {
      "href": "/hi"
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_vm._v(_vm._s(_vm.langName('hi')))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "close"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "lang"
  }, [_c('span', {
    staticClass: "ins"
  }, [_vm._v(_vm._s(_vm.langNameComputed))]), _vm._v(" "), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/ru"
    }
  }, [_vm._v(_vm._s(_vm.langName('ru')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/en"
    }
  }, [_vm._v(_vm._s(_vm.langName('en')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/zh"
    }
  }, [_vm._v(_vm._s(_vm.langName('zh')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/hi"
    }
  }, [_vm._v(_vm._s(_vm.langName('hi')))])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "burger"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone"
  }, [_c('a', {
    attrs: {
      "href": "tel:+78435280548"
    }
  }, [_vm._v("+7 (843) "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("528-05-48")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a878034!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VHeader.vue
// module id = 120
// module chunks = 2